import types from './types'

const showLinkedCalendar = (calendar) => {
  return {
    type: types.SHOW_LINKED_CALENDAR,
    payload: calendar.id,
  }
}
const hideLinkedCalendar = (calendar) => {
  return {
    type: types.HIDE_LINKED_CALENDAR,
    payload: calendar.id,
  }
}

export default {
  showLinkedCalendar,
  hideLinkedCalendar,
}
